export default function compareStrings(a: string, b: string) {
    return (
        a.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') === b.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    );
}
